// Utilities
import {Cookies} from './cookies';

// Consts
const settings = {
    dataAttributes: {
        sectionId: 'data-for-section',
    },

    selectors: {
        // The section IDs available are defined by the HTML present in
        // the header's ".header__section-selector" element
        availableSectionIdElements: 'header .header__section-selector *[data-for-section]',
    },

    cookie: {
        name: 'section',
        expirationDays: 100,
    },
};

/** @type {string[]} */
const availableSectionIds = [];

/** @type {string?} */
let currentSiteSectionId = null;

/**
 * Loads the section ID of the current page based on the current
 * URL. This is stored in a cookie so that the most recently
 * identified section can carry over to pages outside of a specific
 * section, such as the "stay informed" page, where it's used to
 * set the state of the navigation, etc.
 */
export class SiteSection {
    /**
     * Loads the current section state and updates our cookie,
     * if appropriate
     */
    static init() {
        // Determine the list of available section IDs based
        // on the elements present in the header's section selector
        const availableSectionIdElements = document
            .querySelectorAll(settings.selectors.availableSectionIdElements);

        for (let i=0; i<availableSectionIdElements.length; i++) {
            const sectionId = availableSectionIdElements[i]
                .getAttribute(settings.dataAttributes.sectionId);

            availableSectionIds.push(sectionId);
        }

        // Load our cookie
        const storedSiteSectionId = Cookies.read(settings.cookie.name);

        // Check if we're currently on the homepage
        const pathname = window.location.pathname.toLowerCase();
        if (pathname != '/') {
            // We're not on the homepage - check if we're currently
            // within one of the defined sections
            let foundSectionId = null;
            for (let i=0; i<availableSectionIds.length; i++) {
                const availableSectionId = availableSectionIds[i];
                if (pathname.startsWith(availableSectionId)) {
                    foundSectionId = availableSectionId;
                    break;
                }
            }

            if (foundSectionId) {
                // We're within one of the defined sections
                currentSiteSectionId = foundSectionId;
            } else {
                // We're on some page other than the homepage - continue
                // to use the stored site section ID, if present
                currentSiteSectionId = storedSiteSectionId;
            }
        }

        // Update or delete our cookie
        if (currentSiteSectionId !== null) {
            // A section ID was identified - update our cookie regardless
            // of whether the section changed so that the expiration date
            // ticks upward
            Cookies.create(
                settings.cookie.name,
                currentSiteSectionId,
                settings.cookie.expirationDays,
            );
        } else {
            // No section ID was found - delete the cookie if present
            if (storedSiteSectionId !== null) {
                Cookies.delete(settings.cookie.name);
            }
        }
    }

    /**
     * Returns the current section ID, or null
     * @return {string?}
     */
    static get id() {
        return currentSiteSectionId;
    }
}
